import React from "react";
import Header from "./components/Header";
import Middle from "./components/Middle";
import Form from "./components/Form";
import Journey from "./components/Journey";
import Footer from "./components/Footer";
import Nav from "./components/Nav";


function App() {
  
  return (
    <>
      <Nav />
      <Header />
      <Journey />
      <div className="bg-middleBg bg-opacity-[0.15] 2xl:h-[614px]">
        <div className="2xl:container 2xl:flex 2xl:justify-center 2xl:align-middle 2xl:py-[80px] p-4">
          <div className="2xl:float-left 2xl:w-1/3 ">
            <Form />
          </div>
          <div className="2xl:float-right 2xl:w-2/3 pt-[25px]">
            <Middle />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default App;
